
export const paymentIntent = (data, access_token) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/transaction/intent', data, {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}